export interface AddictionalHeaderButton {
  slot: string;
  iconSlot: string;
  iconName: string;
  click: any;
  text: string;
  disabled?: boolean;
}
